// Wrap external image URLs through our /api/proxy-image endpoint so they
// load as first-party assets (ad-blockers ignore them). LinkedIn CDN URLs
// are the main target - uBlock / AdBlock / Brave silently strip licdn.com.
//
// Local URLs (/...), data URIs, and our own domain pass through unchanged.

const PROXY_HOSTS = new Set([
  // LinkedIn CDN - primary target
  'media.licdn.com',
  'static.licdn.com',
  'media-exp1.licdn.com',
  'media-exp2.licdn.com',
  'media-exp3.licdn.com',
  'media-exp4.licdn.com',
  'media-exp5.licdn.com',
  'dms.licdn.com',
  'static-exp1.licdn.com',
  'content.linkedin.com',
  // Google profile pictures (Firebase Auth)
  'lh3.googleusercontent.com',
  'lh4.googleusercontent.com',
  'lh5.googleusercontent.com',
  'lh6.googleusercontent.com',
  // Avatar fallback
  'ui-avatars.com',
]);

function proxyBaseUrl() {
  const configuredBase = process.env.REACT_APP_API_BASE_URL || '';
  if (configuredBase) return configuredBase.replace(/\/+$/, '');

  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost' &&
    window.location.port === '3000'
  ) {
    return 'http://localhost:3001';
  }

  return '';
}

export function proxyImage(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('/') || url.startsWith('data:')) return url;
  try {
    const u = new URL(url);
    if (PROXY_HOSTS.has(u.hostname)) {
      return `${proxyBaseUrl()}/api/proxy-image?url=${encodeURIComponent(url)}`;
    }
    return url;
  } catch (_) {
    return url;
  }
}
